import { render, staticRenderFns } from "./sSelectUbigee.vue?vue&type=template&id=3b16a466"
import script from "./sSelectUbigee.vue?vue&type=script&lang=js"
export * from "./sSelectUbigee.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports